<!-- eslint-disable @angular-eslint/template/no-negated-async -->
<div class="listing" [hidden]="isLoading$ | async" @fadeIn>
  <mat-table [dataSource]="logonsList$ | async" class="listing__table">
    <ng-container matColumnDef="name" class="listing__table__col">
      <mat-header-cell *matHeaderCellDef>Nome</mat-header-cell>
      <mat-cell
        [ngClass]="{ blink: currentUserId === user?.id && updated }"
        *matCellDef="let user"
      >
        <span class="listing__table__col__user-status-name">{{
          user?.name ? user?.name : "-"
        }}</span>
        <pl-me [user]="user.logon"></pl-me>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="document" class="listing__table__col">
      <mat-header-cell *matHeaderCellDef>CPF/RNE</mat-header-cell>
      <mat-cell
        [ngClass]="{ blink: currentUserId === user?.id && updated }"
        *matCellDef="let user"
        >{{ user.document ? user.document : "-" }}</mat-cell
      >
    </ng-container>

    <ng-container matColumnDef="logon" class="listing__table__col">
      <mat-header-cell *matHeaderCellDef>Logon</mat-header-cell>
      <mat-cell
        [ngClass]="{ blink: currentUserId === user?.id && updated }"
        *matCellDef="let user"
        >{{ user.logon ? user.logon : "-" }}</mat-cell
      >
    </ng-container>

    <ng-container matColumnDef="email" class="listing__table__col">
      <mat-header-cell *matHeaderCellDef>E-mail</mat-header-cell>
      <mat-cell
        [ngClass]="{ blink: currentUserId === user?.id && updated }"
        *matCellDef="let user"
        >{{ user.email ? user.email : "-" }}</mat-cell
      >
    </ng-container>

    <ng-container matColumnDef="phone" class="listing__table__col">
      <mat-header-cell *matHeaderCellDef>Celular</mat-header-cell>
      <mat-cell
        [ngClass]="{ blink: currentUserId === user?.id && updated }"
        *matCellDef="let user"
        >{{ user.mobile ? user.mobile : "-" }}</mat-cell
      >
    </ng-container>

    <ng-container matColumnDef="role" class="listing__table__col">
      <mat-header-cell *matHeaderCellDef>Perfil de usuário</mat-header-cell>
      <mat-cell
        [ngClass]="{ blink: currentUserId === user?.id && updated }"
        *matCellDef="let user"
      >
        <span
          [ngClass]="{ '--fill': isSameUser(user) }"
          [sedsTooltip]="userProfileDescription[userProfileEnum[user?.profile]]"
          >{{ userProfileEnum[user?.profile] }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="last_access" class="listing__table__col">
      <mat-header-cell *matHeaderCellDef>Último acesso</mat-header-cell>
      <mat-cell
        [ngClass]="{ blink: currentUserId === user?.id && updated }"
        *matCellDef="let user"
      >
        {{ user.last_access ? user.last_access : "-" }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="status" class="listing__table__col">
      <mat-header-cell
        *matHeaderCellDef
        class="listing__table__col__icon-header-cell-help"
      >
        Status da conta
        <svg
          [sedsTooltip]="
            'Indica a situação atual da conta no Menu de Produtos.'
          "
          xmlns="http://www.w3.org/2000/svg"
          height="20px"
          viewBox="0 -960 960 960"
          width="20px"
          fill="#384553"
        >
          <path
            d="M479.89-240Q500-240 514-253.89q14-13.88 14-34Q528-308 514.11-322q-13.88-14-34-14Q460-336 446-322.11q-14 13.88-14 34Q432-268 445.89-254q13.88 14 34 14Zm.39 144Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Zm-.28-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Zm3.23-172q25.31 0 44.04 16.21Q546-619.59 546-595.28 546-573 533-556t-30 31q-23 20-41 45t-17 56q0 14 10.08 22.5t23.52 8.5q14.4 0 24.4-8.5 10-8.5 13-22.5 5-22 19-38.84 14-16.85 30-32.16 23-22 37.5-49t14.5-58q0-51-39.5-84.5T483.59-720q-37.59 0-71.09 16.5t-53.66 48.77Q351-643 354.5-629t16.5 20q14 7 28 3t23-15q11-14 27-22.5t34.23-8.5Z"
          />
        </svg>
      </mat-header-cell>
      <mat-cell
        [ngClass]="{ blink: currentUserId === user?.id && updated }"
        *matCellDef="let user"
      >
        <span
          class="listing__table__col__user-status {{ user.statusClass }}"
          aria-label="Tooltip informativo sobre o status do usuário"
          [sedsTooltip]="
            formatBlockingReasons(user?.blockageTypes, user?.status)
          "
        >
          @if (user.statusClass === '--active') {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="20px"
            viewBox="0 -960 960 960"
            width="20px"
            fill="#1A4D31"
          >
            <path
              d="m429-438-60-59q-11-11-25-11t-25 11q-11 11-11 25.5t11 25.5l85 85q11 11 25 11t25-11l187-187q11-11 11-25.5T641-599q-11-11-25-11t-25 11L429-438Zm51 342q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96Z"
            />
          </svg>
          } @if (user.statusClass === '--pending') {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="20px"
            viewBox="0 -960 960 960"
            width="20px"
            fill="#9E5612"
          >
            <path
              d="M114.54-139.93q-12.58 0-22.02-5.74-9.43-5.74-14.67-15.13-5.72-9.2-5.22-20.66t6.22-21.84L444.22-813q5.71-10.43 15.58-15.03 9.87-4.6 20.25-4.6t20.2 4.6q9.82 4.6 15.53 15.03l365.37 609.7q5.72 10.38 6.22 21.84.5 11.46-5.22 20.66-5.72 9.19-14.91 15.03-9.2 5.84-21.78 5.84H114.54Zm365.25-124.79q15.45 0 26.43-10.77 10.98-10.76 10.98-26.21 0-15.45-10.77-26.31t-26.22-10.86q-15.45 0-26.43 10.65t-10.98 26.1q0 15.45 10.77 26.42 10.77 10.98 26.22 10.98Zm0-119.28q15.21 0 25.71-10.35T516-420v-117.37q0-15.3-10.29-25.65-10.29-10.35-25.5-10.35t-25.71 10.35Q444-552.67 444-537.37V-420q0 15.3 10.29 25.65Q464.58-384 479.79-384Z"
            />
          </svg>
          } @if (user.statusClass === '--inactive') {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="20px"
            viewBox="0 -960 960 960"
            width="20px"
            fill="#9E5612"
          >
            <path
              d="M114.54-139.93q-12.58 0-22.02-5.74-9.43-5.74-14.67-15.13-5.72-9.2-5.22-20.66t6.22-21.84L444.22-813q5.71-10.43 15.58-15.03 9.87-4.6 20.25-4.6t20.2 4.6q9.82 4.6 15.53 15.03l365.37 609.7q5.72 10.38 6.22 21.84.5 11.46-5.22 20.66-5.72 9.19-14.91 15.03-9.2 5.84-21.78 5.84H114.54Zm365.25-124.79q15.45 0 26.43-10.77 10.98-10.76 10.98-26.21 0-15.45-10.77-26.31t-26.22-10.86q-15.45 0-26.43 10.65t-10.98 26.1q0 15.45 10.77 26.42 10.77 10.98 26.22 10.98Zm0-119.28q15.21 0 25.71-10.35T516-420v-117.37q0-15.3-10.29-25.65-10.29-10.35-25.5-10.35t-25.71 10.35Q444-552.67 444-537.37V-420q0 15.3 10.29 25.65Q464.58-384 479.79-384Z"
            />
          </svg>
          } @if (user.statusClass === '--block') {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="20px"
            viewBox="0 -960 960 960"
            width="20px"
            fill="#851B15"
          >
            <path
              d="M480-162.87q42.28 0 82.45-11.02 40.16-11.02 76.68-32.54L483.65-362.15h-5.32q-66.05.24-128.21 21.38-62.16 21.14-114.92 61.18 49.28 55.48 109.04 86.1Q404-162.87 480-162.87ZM822.83-22.98l-116.81-116.8q-50.19 32.95-107.39 50.43Q541.43-71.87 480-71.87q-84.67 0-159.11-32.1-74.43-32.1-129.63-87.29-55.19-55.2-87.29-129.63-32.1-74.44-32.1-159.11 0-60.43 16.98-117.63 16.98-57.2 50.17-108.15L25.8-820l59.4-59.39L882.22-82.37l-59.39 59.39Zm.26-236.3L591.02-491.35q15.57-18.52 23.23-41.06 7.66-22.55 7.66-47.11 0-58.96-41.48-100.44-41.47-41.47-100.43-41.47-24.57 0-47.11 7.66t-41.06 23.23L259.28-823.09q49.48-31.52 105.48-48.28 56-16.76 115.24-16.76 84.67 0 159.11 32.1 74.43 32.1 129.63 87.29 55.19 55.2 87.29 129.63 32.1 74.44 32.1 159.11 0 59.24-16.76 115.24-16.76 56-48.28 105.48Z"
            />
          </svg>
          } @if (user.statusClass === '--not-found') {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="20px"
            viewBox="0 -960 960 960"
            width="20px"
            fill="#5E6976"
          >
            <path
              d="M312-144q-30 0-51-21t-21-51v-480h-12q-15 0-25.5-10.5T192-732q0-15 10.5-25.5T228-768h156v-12q0-15 10.5-25.5T420-816h120q15 0 25.5 10.5T576-780v12h156q15 0 25.5 10.5T768-732q0 15-10.5 25.5T732-696h-12v480q0 30-21 51t-51 21H312Zm168-261 55 55q11 11 25.5 10.5T586-351q11-11 11-25.5T586-402l-55-54 55-55q11-11 11-25.5T586-562q-11-11-25.5-11T535-562l-55 55-55-55q-11-11-25-11t-25 11q-11 11-11 25.5t11 25.5l54 55-55 55q-11 11-10.5 25t11.5 25q11 11 25.5 11t25.5-11l54-54Z"
            />
          </svg>
          }
          {{ userStatusEnum[user?.status] || "-" }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="mfaStatus" class="listing__table__col">
      <mat-header-cell
        *matHeaderCellDef
        class="listing__table__col__icon-header-cell-help"
        >Status do MFA
        <svg
          [sedsTooltip]="
            'Indica o status da autenticação multifator (MFA) para cada conta.'
          "
          xmlns="http://www.w3.org/2000/svg"
          height="20px"
          viewBox="0 -960 960 960"
          width="20px"
          fill="#384553"
        >
          <path
            d="M479.89-240Q500-240 514-253.89q14-13.88 14-34Q528-308 514.11-322q-13.88-14-34-14Q460-336 446-322.11q-14 13.88-14 34Q432-268 445.89-254q13.88 14 34 14Zm.39 144Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Zm-.28-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Zm3.23-172q25.31 0 44.04 16.21Q546-619.59 546-595.28 546-573 533-556t-30 31q-23 20-41 45t-17 56q0 14 10.08 22.5t23.52 8.5q14.4 0 24.4-8.5 10-8.5 13-22.5 5-22 19-38.84 14-16.85 30-32.16 23-22 37.5-49t14.5-58q0-51-39.5-84.5T483.59-720q-37.59 0-71.09 16.5t-53.66 48.77Q351-643 354.5-629t16.5 20q14 7 28 3t23-15q11-14 27-22.5t34.23-8.5Z"
          />
        </svg>
      </mat-header-cell>
      <mat-cell
        [ngClass]="{ blink: currentUserId === user?.id && updated }"
        *matCellDef="let user"
      >
        <span
          class="listing__table__col__mfa-status"
          [ngClass]="{
            '--enabled': user?.mfaStatus === 'ENABLED',
            '--disabled': user?.mfaStatus === 'DISABLED',
            '--unknown': user?.mfaStatus === 'UNKNOWN'
          }"
          [sedsTooltip]="statusMfaDescription[mfaStatusEnum[user?.mfaStatus]]"
        >
          @if (user?.mfaStatus === 'ENABLED') {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 25 24"
            fill="none"
          >
            <mask
              id="mask0_14076_17637"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="25"
              height="24"
            >
              <rect x="0.5" width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_14076_17637)">
              <path
                d="M11.4502 13.066L9.82721 11.4582C9.68871 11.3197 9.51721 11.2489 9.31271 11.2457C9.10821 11.2425 8.92838 11.3185 8.77321 11.4735C8.62838 11.6185 8.55596 11.7941 8.55596 12.0005C8.55596 12.2068 8.62838 12.3825 8.77321 12.5275L10.8175 14.5717C10.9983 14.7524 11.2092 14.8427 11.4502 14.8427C11.6912 14.8427 11.9021 14.7524 12.083 14.5717L16.2272 10.4275C16.3759 10.2786 16.4492 10.1045 16.4472 9.90521C16.4454 9.70587 16.372 9.52862 16.2272 9.37346C16.072 9.21845 15.8938 9.13837 15.6925 9.13321C15.4913 9.12804 15.3131 9.20304 15.158 9.35821L11.4502 13.066ZM8.90996 21.1832L7.52721 18.8582L4.91171 18.2965C4.68738 18.253 4.50821 18.135 4.37421 17.9427C4.24021 17.7504 4.18671 17.542 4.21371 17.3177L4.46946 14.6275L2.69071 12.5927C2.53688 12.4287 2.45996 12.2313 2.45996 12.0005C2.45996 11.7696 2.53688 11.5722 2.69071 11.4082L4.46946 9.37346L4.21371 6.68321C4.18671 6.45887 4.24021 6.25054 4.37421 6.05821C4.50821 5.86587 4.68738 5.74796 4.91171 5.70446L7.52721 5.14271L8.90996 2.81771C9.03046 2.62037 9.19454 2.48579 9.40221 2.41396C9.60988 2.34212 9.82079 2.35304 10.035 2.44671L12.5002 3.48896L14.9655 2.44671C15.1796 2.35304 15.3905 2.34212 15.5982 2.41396C15.8059 2.48579 15.97 2.62037 16.0905 2.81771L17.4732 5.14271L20.0887 5.70446C20.313 5.74796 20.4922 5.86587 20.6262 6.05821C20.7602 6.25054 20.8137 6.45887 20.7867 6.68321L20.531 9.37346L22.3097 11.4082C22.4635 11.5722 22.5405 11.7696 22.5405 12.0005C22.5405 12.2313 22.4635 12.4287 22.3097 12.5927L20.531 14.6275L20.7867 17.3177C20.8137 17.542 20.7602 17.7504 20.6262 17.9427C20.4922 18.135 20.313 18.253 20.0887 18.2965L17.4732 18.8582L16.0905 21.1832C15.97 21.3805 15.8059 21.5151 15.5982 21.587C15.3905 21.6588 15.1796 21.6479 14.9655 21.5542L12.5002 20.512L10.035 21.5542C9.82079 21.6479 9.60988 21.6588 9.40221 21.587C9.19454 21.5151 9.03046 21.3805 8.90996 21.1832Z"
                fill="#1A4D31"
              />
            </g>
          </svg>
          } @if (user?.mfaStatus === 'DISABLED') {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 21 20"
            fill="none"
          >
            <path
              d="M6.90996 19.1832L5.52721 16.8582L2.91171 16.2965C2.68738 16.253 2.50821 16.135 2.37421 15.9427C2.24021 15.7504 2.18671 15.542 2.21371 15.3177L2.46946 12.6275L0.690711 10.5927C0.536878 10.4287 0.459961 10.2313 0.459961 10.0005C0.459961 9.76962 0.536878 9.57221 0.690711 9.40821L2.46946 7.37346L2.19821 4.42171C2.19188 4.35121 2.20954 4.28387 2.25121 4.21971C2.29288 4.15554 2.34896 4.11704 2.41946 4.10421L2.48671 4.09471L1.15796 2.76571C1.01946 2.62737 0.948628 2.45337 0.945461 2.24371C0.942294 2.03404 1.01313 1.85679 1.15796 1.71196C1.30279 1.56712 1.47846 1.49471 1.68496 1.49471C1.89129 1.49471 2.06688 1.56712 2.21171 1.71196L19.154 18.6542C19.2925 18.7927 19.3633 18.9668 19.3665 19.1765C19.3698 19.386 19.299 19.5632 19.154 19.7082C19.0091 19.853 18.8335 19.9255 18.6272 19.9255C18.4207 19.9255 18.245 19.853 18.1002 19.7082L15.5097 17.1177L15.2887 17.1657L14.0905 19.1832C13.97 19.3805 13.8059 19.5151 13.5982 19.587C13.3905 19.6588 13.1796 19.6479 12.9655 19.5542L10.5002 18.512L8.03496 19.5542C7.82079 19.6479 7.60988 19.6588 7.40221 19.587C7.19454 19.5151 7.03046 19.3805 6.90996 19.1832ZM18.531 12.6275L18.6772 14.2332C18.704 14.4472 18.622 14.5995 18.431 14.69C18.24 14.7803 18.0675 14.7485 17.9137 14.5947L12.9867 9.66771L14.2272 8.42746C14.3759 8.27862 14.4492 8.10454 14.4472 7.90521C14.4454 7.70587 14.372 7.52862 14.2272 7.37346C14.072 7.21845 13.8938 7.13837 13.6925 7.13321C13.4913 7.12804 13.3131 7.20304 13.158 7.35821L11.9175 8.59846L6.37721 3.04271C6.22338 2.88887 6.13554 2.71329 6.11371 2.51596C6.09188 2.31846 6.13288 2.12929 6.23671 1.94846L6.90996 0.817706C7.03046 0.620372 7.19454 0.485788 7.40221 0.413955C7.60988 0.342122 7.82079 0.353038 8.03496 0.446705L10.5002 1.48896L12.9655 0.446705C13.1796 0.353038 13.3905 0.342122 13.5982 0.413955C13.8059 0.485788 13.97 0.620372 14.0905 0.817706L15.4732 3.14271L18.0887 3.70446C18.313 3.74796 18.4922 3.86587 18.6262 4.05821C18.7602 4.25054 18.8137 4.45887 18.7867 4.68321L18.531 7.37346L20.3097 9.40821C20.4635 9.57221 20.5405 9.76962 20.5405 10.0005C20.5405 10.2313 20.4635 10.4287 20.3097 10.5927L18.531 12.6275ZM6.77321 10.5275L8.81746 12.5717C8.99829 12.7524 9.20921 12.8427 9.45021 12.8427C9.69121 12.8427 9.90213 12.7524 10.083 12.5717L10.5232 12.1312L9.54646 11.1542L9.21946 11.4812L7.08871 9.35046C7.04254 9.34529 6.99155 9.35137 6.93571 9.36871C6.88005 9.38604 6.82588 9.42096 6.77321 9.47346C6.61821 9.62862 6.54071 9.80429 6.54071 10.0005C6.54071 10.1966 6.61821 10.3723 6.77321 10.5275Z"
              fill="#ABB1B8"
            />
          </svg>
          } @if (user?.mfaStatus === 'UNKNOWN') {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="20px"
            viewBox="0 -960 960 960"
            width="20px"
            fill="#9E5612"
          >
            <path
              d="m331-99-59-97-110-25q-14-3-22-13.5t-6-24.5l10-113-75-84q-9-11-9-24t9-24l75-84-10-113q-2-14 6-24.5t22-13.5l110-25 59-97q7-11 19.5-15.5t25.5.5l104 45 104-45q13-5 25.5-.5T629-861l59 97 110 25q14 3 22 13.5t6 24.5l-10 113 75 84q9 11 9 24t-9 24l-75 84 10 113q2 14-6 24.5T798-221l-110 25-59 97q-7 11-19.5 15.5T584-84l-104-45-104 45q-13 5-25.5.5T331-99Zm149-189q15 0 25.5-10.5T516-324q0-15-10.5-25.5T480-360q-15 0-25.5 10.5T444-324q0 15 10.5 25.5T480-288Zm0-144q15 0 25.5-10.5T516-468v-168q0-15-10.5-25.5T480-672q-15 0-25.5 10.5T444-636v168q0 15 10.5 25.5T480-432Z"
            />
          </svg>
          }
          {{ mfaStatusEnum[user?.mfaStatus] || "Indisponível" }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions" class="listing__table__col">
      <mat-header-cell *matHeaderCellDef class="listing__table__col__actions"
        >Ações</mat-header-cell
      >
      <mat-cell
        [ngClass]="{ blink: currentUserId === user?.id && updated }"
        class="actions"
        *matCellDef="let user"
      >
        @if (user?.status !== 'INACTIVE' && user?.status !== 'DELETED') {
        <button
          mat-button
          id="statusButton"
          [matMenuTriggerFor]="menu"
          [disabled]="
            user?.status === 'NOT_FOUND' ||
            user?.status === 'DELETED' ||
            !user?.userId
          "
        >
          <mat-icon fontSet="material-icons">more_vert</mat-icon>
        </button>
        }

        <mat-menu class="actions-menu" #menu="matMenu" xPosition="before">
          <button
            mat-menu-item
            (click)="view(user)"
            data-testid="iconeVisualizarUsuario"
          >
            <img
              class="icon"
              alt="ícone de visualizar usuário"
              src="./assets/icons/icon_view_user.svg"
            />Visualizar dados do usuário
          </button>
          <button
            mat-menu-item
            (click)="edit(user)"
            data-testid="iconeEditarUsuario"
          >
            <img
              class="icon"
              alt="ícone de editar usuário"
              src="./assets/icons/icon_edit_user.svg"
            />Editar usuário
          </button>
          <button
            mat-menu-item
            data-testid="iconeAlterarUsuario"
            (click)="changeProfile(user)"
            *ngIf="
              (user.profile === 'USER' || user.profile === 'ACCESS_ADMIN') &&
              !logonTypeLoggedProfileIsUser
            "
          >
            <img
              class="icon"
              alt="ícone de alterar perfil de usuário"
              src="./assets/icons/icon_user.svg"
            />Alterar perfil de usuário
          </button>
          <button
            data-testid="iconeRedefinirUsuario"
            mat-menu-item
            [disabled]="
              !(user?.status === 'PENDING_UPDATE' || user?.status === 'ACTIVE')
            "
            (click)="startResetFlow(user)"
          >
            <img
              class="icon"
              alt="ícone de resetar senha do usuário"
              src="./assets/icons/icon_reset_password.svg"
            />Redefinir senha do usuário
          </button>

          @if ((user?.status === 'PENDING_UPDATE' || user?.status === 'ACTIVE')
          && !isSameUser(user)) {

          <button
            mat-menu-item
            (click)="blockUser(user)"
            data-testid="iconeBloquearUsuario"
          >
            <img
              class="icon"
              alt="Ícone de bloquear usuário"
              src="./assets/icons/icon_block_user.svg"
            />Bloquear usuário
          </button>
          } @if (user?.status === 'BLOCKED' && canUserSeeUnblockedOption(user))
          {
          <button
            mat-menu-item
            (click)="unblockUser(user)"
            data-testid="iconeDesbloquearUsuario"
          >
            <img
              class="icon"
              alt="Ícone de desbloquear usuário"
              src="./assets/icons/icon_unblock_user.svg"
            />Desbloquear usuário
          </button>
          }
          <button
            mat-menu-item
            *appCheckPermissionToDeleteUser="{
              user: user
            }"
            (click)="deleteUser(user)"
            data-testid="iconeExcluirUsuario"
          >
            <img
              class="icon --delete-icon"
              alt="Ícone de desbloquear usuário"
              src="./assets/icons/icon_delete_user.svg"
            />Excluir usuário
          </button>
        </mat-menu>
      </mat-cell>
    </ng-container>

    <div class="no-data-row" *matNoDataRow>
      @if ((showEmptyList$ | async) && !(error$ | async)) {
      <pl-empty-list screenName="dashboard"></pl-empty-list>
      } @if (error$ | async) {
      <pl-error-message></pl-error-message>
      }
    </div>

    <mat-header-row *matHeaderRowDef="tableCols"></mat-header-row>
    <mat-row *matRowDef="let row; columns: tableCols"></mat-row>
  </mat-table>

  <mat-paginator
    class="listing__paginator"
    (page)="handlePageEvent($event)"
    [length]="pageEvent.length"
    [pageSize]="pageEvent.pageSize"
    aria-label="Selecione a página"
    showFirstLastButtons
    hidePageSize
  >
  </mat-paginator>
</div>

@if (isLoading$ | async) {<pl-skeleton></pl-skeleton>}
